import type { ComposerImageAttachment } from "../../composerDraftStore";

interface NewThreadImageTransferInput {
  readonly images: ReadonlyArray<ComposerImageAttachment>;
  readonly onTransferStarted?:
    | ((images: ReadonlyArray<ComposerImageAttachment>) => void)
    | undefined;
  readonly onTransferCancelled?:
    | ((images: ReadonlyArray<ComposerImageAttachment>) => void)
    | undefined;
  readonly createThread: () => Promise<unknown>;
  readonly hydrateDraft: () => boolean;
}

export async function runNewThreadImageTransfer(input: NewThreadImageTransferInput): Promise<void> {
  input.onTransferStarted?.(input.images);
  try {
    await input.createThread();
    if (!input.hydrateDraft()) input.onTransferCancelled?.(input.images);
  } catch (cause: unknown) {
    input.onTransferCancelled?.(input.images);
    throw cause;
  }
}
